import styled from 'styled-components';

import Box from 'relements/build/esm/ui/box';
import Icon from 'relements/build/esm/ui/icon';
import Button from 'relements/build/esm/ui/button';

const ContainerStyle = () => ({
  flexDirection: 'column',
  flex: 1,
  padding: '30px 0 30px 25px',
  overflowY: 'auto',
});

export const Container = styled(Box)(ContainerStyle);

const IconStyle = (props) => ({
  height: `${props.height} !important`,
  width: `${props.width} !important`,
});
export const SvgIcon = styled(Icon)(IconStyle);

export const ButtonStyle = (props) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '16px',
  padding: '10px 14px',
  width: props.width || 'auto',
  marginRight: props.marginRight || 0,
});

export const CustomButton = styled(Button)(ButtonStyle);
